import header from './header/header'
import grid from './grid/grid'

export default function(o, done){

  var lang = o.store('lang')
  var projectLabel = o.util.getTranslation(o, 'project')
  var queryProject = location.pathname.split('/')[2]

  o.data.archive(o, function(archiveData){

    document.title = `Open Memory Box | ${projectLabel} ${queryProject}`

    var tagsById =
      _.keyBy(archiveData.tags, '_id')

    var projectMarkers =
      _.sortBy(
        _.filter(archiveData.markers, function(marker){
          var project = marker.roll.split('-')[0]
          return project == queryProject
        }),
        function(marker){
          return marker.roll + marker.start
        },
      )

    var results =
      _.map(projectMarkers, function(marker){

        var roll = marker.roll
        var start = marker.start
        var tag = tagsById[marker.tag]

        if(!tag){
          return null
        }

        var result = {
          roll: roll,
          start: start,
          tag: tag,
        }

        return result

      })

    var results = _.compact(results)

    var gridDiv = grid(o, results, queryProject)

    var headerDiv = header(o, queryProject)

    var div =$('<div>')
    .css(o.mainDivCss)
    .addClass('iphoneNavbarFixTop')
    .addClass('iphoneNavbarFixBottom')  
    .append([

      headerDiv
      .css({
        flex: '0 0 auto',
        width: '100%',
      }),

      gridDiv
      .css({
        flex: '1 1 auto',
        width: '100%',
        overflowY: 'auto',
        '-webkit-overflow-scrolling': 'touch',
        minHeight: 0,
      }),

    ])

    var observer =
      new MutationObserver(function(){
        if (document.body.contains(div[0])){

          observer.disconnect()

          gridDiv.update()

          if(o.store('archiveScrollTop_' + queryProject)){
            gridDiv.scrollTop(o.store('archiveScrollTop_' + queryProject))
          }

        }
      })

    observer.observe(document.body, {childList: true});

    done(div)

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/box/box.js